// This file is auto-generated - any changes will be lost

// Page Files
import "../../src/js/pages/AboutUs.js";
import "../../src/js/pages/CaseStudies.js";
import "../../src/js/pages/Contact.js";
import "../../src/js/pages/Discrimination.js";
import "../../src/js/pages/EquipInTheCommunity.js";
import "../../src/js/pages/Index.js";
import "../../src/js/pages/ProjectInner.js";
import "../../src/js/pages/Projects.js";
import "../../src/js/pages/Resources.js";
import "../../src/js/pages/TakeAction.js";
import "../../src/js/pages/Training.js";